import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEntryUsersSchemas } from 'shared/db/validation/schema/entryUsers';
import { Validator } from 'shared/db/validation/validator';
import {
    EntryUserRawRecord,
    EntryUserUpdateRawRecord,
} from 'shared/types/EntryUser';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EntryUserDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEntryUsersSchemas();

const addValidator = createDBEntityValidator<EntryUserRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<EntryUserUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-entry-users'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEntryUsersInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const entryUsersInputValidation: EntryUserDBValidation = {
    add: createEntryUsersInputValidation(addValidator, validationStrategy),
    update: createEntryUsersInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEntryUsersInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
